// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  --zoom: 1;
}
@media (height < 770px) {
  :host {
    --zoom: 0.9;
  }
}

ion-content {
  --background: url('home-bg.png') no-repeat center center/ 100% 100%;
}
@media (min-width: 991px) {
  ion-content {
    --background: url('home-bg-desk.png') no-repeat center center/ 150% 100%;
  }
}

.content-row {
  height: 100%;
}
.content-row .content-col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 0 35px;
}

.brand-logo {
  height: 22vh;
  width: 100%;
  margin-bottom: 20px;
  zoom: var(--zoom);
}

.card {
  display: flex;
  flex-direction: column;
  background: var(--ion-color-primary);
  border-radius: 8px;
  padding: 20px 17px;
  margin: 80px auto 20px;
  min-width: 300px;
  max-width: 375px;
  text-align: center;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.4);
  will-change: auto;
}
@media (height < 770px) {
  .card {
    margin: 40px auto 20px;
    padding: 12px;
  }
}
.card .cocktail-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-bottom: 18px;
  zoom: var(--zoom);
}
.card .cocktail-block .cocktail {
  height: 20px;
  width: 20px;
}
.card .cocktail-block .cocktail-text {
  font-family: AppFont;
  font-size: 14px;
  line-height: 135%;
  text-align: center;
  text-wrap: balance;
}

ion-footer {
  zoom: var(--zoom);
  --background: transparent;
  background: transparent;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  box-shadow: none;
  --box-shadow: none;
}

.footer-lang {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  max-width: max-content;
  margin: 0 auto;
}
.footer-lang div {
  height: 44px;
  width: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  border-width: 0.5px;
  border-style: solid;
  border-color: #000000;
  transition: box-shadow 0.2s linear;
  background: #898988;
}
.footer-lang div p {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0.02em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--color-white);
}
.footer-lang div ion-icon {
  height: 23px;
  width: 23px;
  border-radius: 50px;
  overflow: hidden;
  margin-right: 4.5px;
}
.footer-lang div.selected {
  background: var(--ion-color-primary);
  box-shadow: 2px 2px 0px 2px #000000;
}
.footer-lang div.selected p {
  color: #0f0f0e;
}

.lang-block {
  padding-bottom: 25px;
}

.title,
.info-text {
  zoom: var(--zoom);
  font-family: AppFont;
  font-size: 14px;
  line-height: 135%;
  text-align: center;
  text-wrap: balance;
  margin-bottom: 16px;
}

.info-text {
  margin-top: 16px;
  margin-bottom: 4px;
}

.payment-block {
  zoom: var(--zoom);
  padding-block: 12px;
  border-top: 0.5px solid rgba(69, 73, 78, 0.5333333333);
  border-bottom: 0.5px solid rgba(69, 73, 78, 0.5333333333);
  margin-bottom: 16px;
}
.payment-block .payment-info {
  font-family: AppFontMedium;
  font-size: 10px;
  line-height: 135%;
  text-align: center;
  vertical-align: middle;
  margin-bottom: 12px;
}
.payment-block .payment-icons {
  width: 100%;
  height: 16px;
}

.alergen-link {
  padding-bottom: 12px;
  cursor: pointer;
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 120%;
  text-align: center;
  color: var(--color-black);
  text-align: center;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 10%;
  text-underline-offset: 2px;
}

.subtitle {
  display: block;
  font-family: AppFontSemiBold;
  font-size: 24px;
  color: #1d1d1b;
  margin-bottom: 8px;
  text-wrap: balance;
  padding-block: 8px;
  margin-bottom: 10px;
}
@media (height < 770px) {
  .subtitle {
    font-size: 12px;
  }
}

.preorder-title {
  font-family: AppFont;
  font-size: 16px;
  font-weight: 500;
  color: #1d1d1b;
}
@media (height < 770px) {
  .preorder-title {
    font-size: 14px;
  }
}

@media (height < 770px) {
  .btn {
    height: 40px !important;
  }
}

.pointer {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/home/home.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AASA;EACC,SAAA;AARD;AASC;EAFD;IAGE,WAAA;EANA;AACF;;AASA;EACC,mEAAA;AAND;ACVE;EDeF;IAGE,wEAAA;EAJA;AACF;;AAOA;EACC,YAAA;AAJD;AAMC;EACC,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;AAJF;;AAQA;EACC,YAAA;EACA,WAAA;EACA,mBAAA;EAEA,iBAAA;AAND;;AASA;EACC,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+CAAA;EACA,iBAAA;AAND;AAQC;EAbD;IAcE,sBAAA;IACA,aAAA;EALA;AACF;AAOC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;AALF;AAOE;EACC,YAAA;EACA,WAAA;AALH;AAQE;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kBAAA;AAPH;;AAYA;EACC,iBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AATD;;AAWA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;AARD;AAUC;EACC,YAAA;EACA,WAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EAEA,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kCAAA;EAEA,mBAAA;AAXF;AAaE;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,yBAAA;AAZH;AAcE;EACC,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAZH;AAeE;EACC,oCAAA;EACA,mCAAA;AAbH;AAeG;EACC,cAAA;AAbJ;;AAmBA;EACC,oBAAA;AAhBD;;AAmBA;;EAEC,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kBAAA;EAEA,mBAAA;AAlBD;;AAoBA;EACC,gBAAA;EACA,kBAAA;AAjBD;;AAoBA;EACC,iBAAA;EACA,mBAAA;EACA,sDAAA;EACA,yDAAA;EACA,mBAAA;AAjBD;AAmBC;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;AAjBF;AAoBC;EACC,WAAA;EACA,YAAA;AAlBF;;AAqBA;EACC,oBAAA;EACA,eAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,0BAAA;AApBD;;AAuBA;EACC,cAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AApBD;AAsBC;EAVD;IAWE,eAAA;EAnBA;AACF;;AAsBA;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAnBD;AAqBC;EAND;IAOE,eAAA;EAlBA;AACF;;AAsBC;EADD;IAEE,uBAAA;EAlBA;AACF;;AAqBA;EACC,eAAA;AAlBD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n// .home-bg {\n// \tbackground: url('../../../assets/bjorn/versal-home-bg.jpg') no-repeat center center fixed;\n// \tbackground-size: cover;\n// \twidth: auto;\n// \theight: 100%;\n// }\n\n:host {\n\t--zoom: 1;\n\t@media (height < 770px) {\n\t\t--zoom: 0.9;\n\t}\n}\n\nion-content {\n\t--background: url('../../../assets/bjorn/home-bg.png') no-repeat center center/ 100% 100%;\n\t@include desktop {\n\t\t--background: url('../../../assets/bjorn/home-bg-desk.png') no-repeat center center/ 150% 100%;\n\t}\n}\n\n.content-row {\n\theight: 100%;\n\n\t.content-col {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\tpadding: 0 35px;\n\t}\n}\n\n.brand-logo {\n\theight: 22vh;\n\twidth: 100%;\n\tmargin-bottom: 20px;\n\n\tzoom: var(--zoom);\n}\n\n.card {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground: var(--ion-color-primary);\n\tborder-radius: 8px;\n\tpadding: 20px 17px;\n\tmargin: 80px auto 20px;\n\tmin-width: 300px;\n\tmax-width: 375px;\n\ttext-align: center;\n\tbox-shadow: 0px 4px 10px 0px #00000066;\n\twill-change: auto;\n\n\t@media (height < 770px) {\n\t\tmargin: 40px auto 20px;\n\t\tpadding: 12px;\n\t}\n\n\t.cocktail-block {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 8px;\n\t\tmargin-bottom: 18px;\n\t\tzoom: var(--zoom);\n\n\t\t.cocktail {\n\t\t\theight: 20px;\n\t\t\twidth: 20px;\n\t\t}\n\n\t\t.cocktail-text {\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 135%;\n\t\t\ttext-align: center;\n\n\t\t\ttext-wrap: balance;\n\t\t}\n\t}\n}\n\nion-footer {\n\tzoom: var(--zoom);\n\t--background: transparent;\n\tbackground: transparent;\n\toverflow: hidden;\n\tposition: absolute;\n\tbottom: 0;\n\tbox-shadow: none;\n\t--box-shadow: none;\n}\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 12px;\n\tmax-width: max-content;\n\tmargin: 0 auto;\n\n\tdiv {\n\t\theight: 44px;\n\t\twidth: 84px;\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\tborder-radius: 4px;\n\n\t\tborder-width: 0.5px;\n\t\tborder-style: solid;\n\t\tborder-color: #000000;\n\t\ttransition: box-shadow 0.2s linear;\n\n\t\tbackground: #898988;\n\n\t\tp {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 135%;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n\n\t\t\tcolor: var(--color-white);\n\t\t}\n\t\tion-icon {\n\t\t\theight: 23px;\n\t\t\twidth: 23px;\n\t\t\tborder-radius: 50px;\n\t\t\toverflow: hidden;\n\t\t\tmargin-right: 4.5px;\n\t\t}\n\n\t\t&.selected {\n\t\t\tbackground: var(--ion-color-primary);\n\t\t\tbox-shadow: 2px 2px 0px 2px #000000;\n\n\t\t\tp {\n\t\t\t\tcolor: #0f0f0e;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.lang-block {\n\tpadding-bottom: 25px;\n}\n\n.title,\n.info-text {\n\tzoom: var(--zoom);\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 135%;\n\ttext-align: center;\n\n\ttext-wrap: balance;\n\n\tmargin-bottom: 16px;\n}\n.info-text {\n\tmargin-top: 16px;\n\tmargin-bottom: 4px;\n}\n\n.payment-block {\n\tzoom: var(--zoom);\n\tpadding-block: 12px;\n\tborder-top: 0.5px solid #45494e88;\n\tborder-bottom: 0.5px solid #45494e88;\n\tmargin-bottom: 16px;\n\n\t.payment-info {\n\t\tfont-family: AppFontMedium;\n\t\tfont-size: 10px;\n\t\tline-height: 135%;\n\t\ttext-align: center;\n\t\tvertical-align: middle;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.payment-icons {\n\t\twidth: 100%;\n\t\theight: 16px;\n\t}\n}\n.alergen-link {\n\tpadding-bottom: 12px;\n\tcursor: pointer;\n\n\tfont-family: AppFontMedium;\n\tfont-size: 14px;\n\tline-height: 120%;\n\ttext-align: center;\n\n\tcolor: var(--color-black);\n\ttext-align: center;\n\ttext-decoration: underline;\n\ttext-decoration-style: solid;\n\ttext-decoration-thickness: 10%;\n\ttext-underline-offset: 2px;\n}\n\n.subtitle {\n\tdisplay: block;\n\tfont-family: AppFontSemiBold;\n\tfont-size: 24px;\n\tcolor: #1d1d1b;\n\tmargin-bottom: 8px;\n\ttext-wrap: balance;\n\tpadding-block: 8px;\n\tmargin-bottom: 10px;\n\n\t@media (height < 770px) {\n\t\tfont-size: 12px;\n\t}\n}\n\n.preorder-title {\n\tfont-family: AppFont;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tcolor: #1d1d1b;\n\n\t@media (height < 770px) {\n\t\tfont-size: 14px;\n\t}\n}\n\n.btn {\n\t@media (height < 770px) {\n\t\theight: 40px !important;\n\t}\n}\n\n.pointer {\n\tcursor: pointer;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
